import React, { SVGProps } from 'react'
const SvgBudgetCreateLabel = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M11.675 5.625a7.199 7.199 0 1 1-6.23 10.853l-.04-.082a.5.5 0 0 1 .22-.604l5.606-3.254-.057-6.408a.5.5 0 0 1 .501-.505Zm.504 1.024.054 6.17-.007.09a.5.5 0 0 1-.242.348l-5.403 3.136.057.084a6.199 6.199 0 1 0 5.644-9.82l-.103-.008Z"
      />
      <path
        fill="#FFF"
        d="M11.692 5.289a7.565 7.565 0 0 0-6.546 11.403l6.517-3.84.029-7.563Z"
      />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M11.693 4.789a.5.5 0 0 1 .499.501l-.029 7.563a.5.5 0 0 1-.246.43L5.4 17.122a.5.5 0 0 1-.685-.178 8.064 8.064 0 0 1 6.978-12.156Zm-.528 7.776.025-6.76-.035.002a7.05 7.05 0 0 0-5.333 3.074l-.155.239a7.062 7.062 0 0 0-.354 6.826l.027.052 5.825-3.433Z"
      />
      <path fill="#FFF" d="M16.811 11.5h3v3h-3z" />
      <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
        <path d="M21.407 13.52a.5.5 0 0 0 .09-.991l-.09-.008H14.61a.5.5 0 0 0-.09.992l.09.008h6.796Z" />
        <path d="M20.065 15.584a.5.5 0 0 0 .64-.02l.062-.066 1.7-2.169a.5.5 0 0 0 .052-.535l-.052-.082-1.7-2.17a.5.5 0 0 0-.836.54l.049.076 1.458 1.863-1.458 1.86a.5.5 0 0 0 .02.64l.065.063Z" />
      </g>
    </g>
  </svg>
)
export default SvgBudgetCreateLabel
